const CS2030STA = {
  jobTitle: "University Teaching Assistant",
  company: "National University of Singapore",
  duration: "Aug 2020 - Nov 2020",
  description:
    "Taught Object-oriented and Functional Programming in a Computing module (CS2030)",
  jobscope: [
    "Conducted scheduled sessions to facilitate learning of object-oriented/functional programming",
    "Assessed assignments and gave feedback to students' code",
    "Built students' proficiency in Java",
  ],
  funFact:
    "My first time tutoring. It was hard work and long hours but seeing students excel is something I am very proud of!",
};

export default CS2030STA;
